import React, { useEffect, useState } from 'react';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import classnames from 'classnames';

export const TextFileDownloader = ({ list, disabled, fileName }) => {
  const [downloadLink, setDownloadLink] = useState('');

  const makeTextFile = () => {
    const data = new Blob([list.join('\n')], { type: 'text/plain' });

    // this part avoids memory leaks
    if (downloadLink !== '') window.URL.revokeObjectURL(downloadLink);

    // update the download link state
    setDownloadLink(window.URL.createObjectURL(data));
  };

  // Call the function if list changes
  useEffect(() => {
    !disabled && makeTextFile();
  }, [list]);

  return disabled ? (
    <SvgAF img={IconLoader.icon_export} hover={IconLoader.icon_export} />
  ) : (
    <a
      // className={classnames({ isDisabled: disabled })}
      download={`${fileName}.txt`}
      href={downloadLink}
      data-tip={'export data into text file'}
    >
      <SvgAF img={IconLoader.icon_export} hover={IconLoader.icon_export_hover} />
    </a>
  );
};

export default TextFileDownloader;

